/// <amd-module name="VC/Common/Contracts/EnumToString" />
import { PullRequestStatus } from "VC/Common/Contracts/Git";

// Contract enums are now const enums and so we can't rely on the old typescript trick of it being an object that contains both number and string
export function pullRequestStatusToString(status: PullRequestStatus) { 
    switch(status)
    {
        case PullRequestStatus.Abandoned:
            return "Abandoned";
        case PullRequestStatus.All:
            return "All";
        case PullRequestStatus.Completed:
            return "Completed";
        default:
            return "Active";
    }
}
